import { useLocation } from 'react-router-dom';

import { Box, CircularProgress } from '@parspec/pixel';

import AccountDetailsTab from './AccountDetailsTab';
import SecurityTab from './SecurityTab';
import PreferencesTab from './PreferencesTab';
import Header from './Header';
import { useGetUserProfileInfoQuery } from './queries';
import { TAB_VALUES } from './utils/utils';

export const MyProfile = () => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const tabValue = params?.get('tab');

    const { isLoading: userProfileLoading } = useGetUserProfileInfoQuery();

    const getTabContent = () => {
        const tabContent = {
            [TAB_VALUES.ACCOUNT_DETAILS]: <AccountDetailsTab />,
            [TAB_VALUES.SECURITY]: <SecurityTab />,
            [TAB_VALUES.PREFERENCES]: <PreferencesTab />
        };

        if (tabValue && tabContent[tabValue as keyof typeof tabContent]) {
            return tabContent[tabValue as keyof typeof tabContent];
        }
        return <AccountDetailsTab />;
    };

    return (
        <>
            <Box py={4} width="calc(100vw - 390px)" sx={{ overflow: 'hidden' }} minWidth={'942px'} height="calc(100vh - 130px)" bgcolor="secondary.contrastText">
                {userProfileLoading ? (
                    <Box display="flex" justifyContent="center" alignItems="center" width={1} height={1}>
                        <CircularProgress color="primary" size={'xxl'} />
                    </Box>
                ) : (
                    <>
                        <Header />
                        <Box mt={6} px={4} overflow="auto" height="calc(100% - 100px)">
                            {getTabContent()}
                        </Box>
                    </>
                )}
            </Box>
        </>
    );
};
